import { Notyf } from "notyf";
import type { App, InjectionKey } from "vue";

export interface Toaster {
  success: (text: string) => void;
  error: (text: string) => void;
}

const toasterClassName = 'tr-toaster';

export const ToasterIK: InjectionKey<Toaster> = Symbol('ToasterIK');

export const createToaster = () => {
  const notyf = new Notyf({
    duration: 5000,
    dismissible: true,
    ripple: false,
    position: {
      x: 'right',
      y: 'top'
    },
    types: [
      {
        type: 'success',
        background: '#00aef3',
        icon: false,
        className: `${toasterClassName} ${toasterClassName}--success`
      },
      {
        type: 'error',
        icon: false,
        background: '#ff3569',
        className: `${toasterClassName} ${toasterClassName}--error`
      }
    ]
  });

  return {
    install: (app: App) => {
      app.provide(ToasterIK, {
        success: text => notyf.success(text),
        error: text => notyf.error(text)
      });
    }
  }
};
